<template>
  <div class="shadows">
    <div class="shadow-1" />
    <div class="shadow-2" />
    <div class="shadow-3" />
    <div class="shadow-4" />
    <div class="shadow-5" />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/global/palette";

$red: palette.$destructive-50;

.shadows {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.shadow-1 {
  position: absolute;
  left: 1%;
  right: 1%;
  top: -25vh;
  height: 25.5vh;
  background: rgba($red, 0.5);
  border-radius: 8px;
}

.shadow-2 {
  position: absolute;
  left: 5.5%;
  right: 5.5%;
  top: -22.6vh;
  height: 24.6vh;
  background: rgba($red, 0.25);
  border-radius: 8px;
}

.shadow-3 {
  position: absolute;
  left: 18.5%;
  right: 18.5%;
  top: -22.6vh;
  height: 25.8vh;
  background: rgba($red, 0.25);
  border-radius: 8px;
}

.shadow-4 {
  position: absolute;
  left: 25.5%;
  right: 25.5%;
  top: -22.6vh;
  height: 28.8vh;
  background: rgba($red, 0.25);
  border-radius: 8px;
}

.shadow-5 {
  position: absolute;
  left: 32%;
  right: 32%;
  top: -22.6vh;
  height: 31.5vh;
  background: rgba($red, 0.25);
  border-radius: 8px;
}
</style>
